import { motion } from "framer-motion";
import { Upload, Sparkles, Cpu, Users, FileCheck } from "lucide-react";

const STEPS = [
  { icon: Upload, title: "Upload skin image", desc: "Drag-and-drop a dermoscopic or clinical photograph. JPG, PNG or HEIC." },
  { icon: Sparkles, title: "AI preprocesses image", desc: "Denoising, color normalisation and lesion isolation via semantic segmentation." },
  { icon: Cpu, title: "Deep model predicts", desc: "CNN + DenseNet121 + SwinViT ensemble outputs a probability distribution across 7+ classes." },
  { icon: Users, title: "Agents validate", desc: "Classifier, Validator and Safety agents cross-reference ISIC and veto low-confidence calls." },
  { icon: FileCheck, title: "Report generated", desc: "A structured clinical summary with severity, reasoning and next-step recommendations." },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-2xl">
          <div className="text-xs uppercase tracking-[0.22em] font-bold text-slate-500">
            <span className="font-mono-num">03</span> · Workflow
          </div>
          <h2 className="font-heading mt-4 text-4xl sm:text-5xl tracking-tight font-light text-slate-900">
            Five steps from <br /> image to <em className="not-italic text-slate-400">insight</em>.
          </h2>
        </div>

        <div className="relative mt-16">
          <div className="absolute left-[23px] md:left-[27px] top-4 bottom-4 w-px bg-gradient-to-b from-slate-200 via-slate-300 to-slate-100" />
          <ol className="space-y-10">
            {STEPS.map((s, i) => {
              const Icon = s.icon;
              return (
                <motion.li
                  key={s.title}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.55, delay: i * 0.08 }}
                  className="relative flex gap-6"
                  data-testid={`step-${i + 1}`}
                >
                  <div className="relative z-10 flex-shrink-0">
                    <div className="h-12 w-12 rounded-xl bg-white ring-1 ring-slate-200 flex items-center justify-center shadow-sm">
                      <Icon className="h-5 w-5 text-slate-700" />
                    </div>
                  </div>
                  <div className="flex-1 pt-1">
                    <div className="flex items-center gap-3">
                      <div className="text-[10px] uppercase tracking-[0.25em] font-mono-num text-slate-400">
                        Step 0{i + 1}
                      </div>
                      <div className="h-px flex-1 bg-slate-100" />
                    </div>
                    <h3 className="font-heading mt-1 text-xl text-slate-900">{s.title}</h3>
                    <p className="mt-1 text-slate-600 max-w-xl">{s.desc}</p>
                  </div>
                </motion.li>
              );
            })}
          </ol>
        </div>
      </div>
    </section>
  );
}
